import React, { useEffect } from 'react';
import ProductPage from './components/ProductPage';
export function App() {
  useEffect(() => {
    // Set the exact title as requested
    document.title = 'Personalised Gifting Store';
    console.log('Title set to:', document.title);
  }, []);
  return <ProductPage data-id="element-0" />;
}